import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { AutocompleteParams } from "apis/data-contracts";
import useDebouncedState from "features/common/hooks/useDebouncedState";

const useNoticesAutoCompleteQuery = (options: AutocompleteParams) => {
  const option = useDebouncedState(options, 500);

  return useQuery({
    queryKey: api.notice.autocomplete1Key(option as AutocompleteParams),
    queryFn: () => api.notice.autocomplete1(option as AutocompleteParams),
    enabled: option?.keyword !== undefined && option?.keyword.trim() !== "",
    placeholderData: (pre) => pre,
  });
};

export default useNoticesAutoCompleteQuery;
